import { COMPANY_DROPDOWN_QUERY } from "@app/shared/crm/company/quries/company-dropdown.query";
import { LOCATION_DROPDOWN_QUERY } from "@app/shared/company-hierarchy/locations/queries/location-dropdown.query";
import { VEHICLE_DROPDOWN_QUERY } from "@app/shared/fleet/vehicle/queries/vehicle-dropdown.query";
import { CREATED_BY_QUERY } from "@app/shared/users/users/queries/created-by.query";

/** GraphQL selection for the vehicle transfer form. */
export const VEHICLE_TRANSFER_FORM_QUERY = `
  id
  entityId
  transferType
  company { ${COMPANY_DROPDOWN_QUERY} }
  pickUpLocation { ${LOCATION_DROPDOWN_QUERY} }
  dropOffLocation { ${LOCATION_DROPDOWN_QUERY} }
  dropOffAddress
  startAt
  expectedEndAt
  vehicles {
    ${VEHICLE_DROPDOWN_QUERY}
    onboarding { id status }
  }
  deliveredVehicles { id }
  files
  signedDeliveryTdFiles
  signedPickupTdFiles
  isInOnboarding
  status
  createdAt
  updatedAt
  createdBy { ${CREATED_BY_QUERY} }
  canUpdate
  canCancel
  canMarkDelivered
  canMarkPickedUp
  canReschedule
`;
